import { render } from "./EditCustomerForm.vue?vue&type=template&id=36373e9a&lang=pug"
import script from "./EditCustomerForm.vue?vue&type=script&lang=js"
export * from "./EditCustomerForm.vue?vue&type=script&lang=js"

import "./EditCustomerForm.vue?vue&type=style&index=0&id=36373e9a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__